module.exports = __webpack_public_path__ + "img/logo.b35eef5f.webp";